import { FatalErrorKey } from '@hec/models';

export const SET_FATAL_ERROR_KEY = 'SET_FATAL_ERROR_KEY';

export const SetFatalErrorKey = (fatalErrorKey: FatalErrorKey, data: unknown = {}) =>
  ({ type: SET_FATAL_ERROR_KEY, data: { fatalErrorKey: fatalErrorKey, data } });
